import { render, staticRenderFns } from "./IdCardTemplate.vue?vue&type=template&id=24d00650&"
import script from "./IdCardTemplate.vue?vue&type=script&lang=js&"
export * from "./IdCardTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports